// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    Link,
    useLocation,
} from 'react-router-dom'

// components
import {
    FormDataDisplaySite,
    ImageHelperSite,
    LinkHelperSite,
} from 'components'

// services
import {
    getStylesToRetrieve,
} from 'services'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
    reduxSalesCartToggleSite,
    reduxSalesRemoveFromCartSite,
} from 'data'

// main
export const CartPopUpBlockSite: React.FC = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const reduxCacheSite = useSelector((state: defaultReduxState) => state.reduxCacheSite)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxSalesSite = useSelector((state: defaultReduxState) => state.reduxSalesSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const deviceType = reduxModalSite.deviceType

    const [fontFamily, setFontFamily] = useState<string>()

    useEffect(() => {
        setFontFamily(getStylesToRetrieve(reduxModalSite, undefined, reduxCacheSite.portfolio?.styles, '', 'fontFamily'))
    }, [
        reduxCacheSite.portfolio?.styles,
        reduxModalSite,
    ])

    function handleClose() {
        try {
            dispatch(reduxSalesCartToggleSite(false))
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'CartPopUpBlockSite',
                'handleClose',
            ))
        }
    }

    function scrollToTop() {
        try {
            // Scroll to top when on checkout page
            if (location.pathname.includes('/checkout')) {
                const contentElement = document.getElementById(`mo-content-slug-id-site-checkout`)
                if (contentElement?.scrollTo) {
                    contentElement.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
                }
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'CartPopUpBlockSite',
                'scrollToTop',
            ))
        }
    }

    if (!reduxCacheSite.portfolio?.is_eshop) return null

    const canCheckout = process.env.NODE_ENV === 'production' ? (Boolean(reduxCacheSite.portfolio.token_stripe_public) || Boolean(reduxCacheSite.portfolio.token_paypal_client_id)) : true

    return (
        <div
            className={`cart-popup-block ${reduxSalesSite.isCartOpen ? 'open' : ''} ${deviceType}`}
            style={{
                fontFamily: fontFamily,
            }}
        >
            <div
                className={`cpb-backdrop ${deviceType}`}
                onClick={handleClose}
            />
            <i
                className={`cpb-close mo-new-icon-times-solid ${deviceType}`}
                onClick={handleClose}
            />
            {reduxSalesSite.isCartOpen && (
                <div className={`cpb-content ${deviceType}`}>
                    <div className={`cpb-cart-list ${deviceType}`}>
                        <p className={`cpb-cart-total ${deviceType}`}>
                            {reduxText[7465]}
                        </p>
                        {reduxSalesSite.salesLines.length === 0 && (
                            <p className={`cpb-cart-empty ${deviceType}`}>
                                {reduxText[7466]}
                            </p>
                        )}
                        {reduxSalesSite.salesLines.map((val, i) => {

                            return (
                                <div key={`cpb-item-${i}`} className={`cpb-item-wrapper ${deviceType}`}>
                                    <div className={`cpb-lines ${deviceType}`}>
                                        <Link
                                            className={`cpb-image-wrap ${deviceType}`}
                                            onClick={handleClose}
                                            to={val.absolute_url}
                                        >
                                            <ImageHelperSite
                                                alt={val.product.name}
                                                className={`cpb-image ${deviceType}`}
                                                dominant_color={undefined}
                                                src={val.product.get_image_site_lq}
                                            />
                                        </Link>
                                        <div className={`cpb-info ${deviceType}`}>
                                            <div className={`cpb-info-wrap ${deviceType}`}>
                                                <span className={`cpb-name ${deviceType}`}>
                                                    {val.product.name}
                                                </span>
                                                {val.variant && (
                                                    <span className={`cpb-variant ${deviceType}`}>
                                                        {val.variant.name}
                                                    </span>
                                                )}
                                                {/* {val.package_option_items?.map((item) => {
                                            return (
                                                <span
                                                    key={item.id}
                                                    className={`cpb-package-option ${deviceType}`}
                                                >
                                                    {item.package_option?.name && `${item.package_option.name}: `}
                                                    {item.product?.name}
                                                    {item.qty ? ` (x${item.qty})` : ''}

                                                    {item.form_data && Object.keys(item.form_data).length > 0 && (
                                                        <div className={`cpb-package-option-form-data ${deviceType}`}>
                                                            {Object.entries(item.form_data).map(([fieldName, fieldData]) => {
                                                                // Check if the data has the structure with label and value
                                                                if (fieldData && typeof fieldData === 'object' && 'label' in fieldData && 'value' in fieldData) {
                                                                    const { label, value } = fieldData as { label: string, value: any }

                                                                    // Format the field value
                                                                    let formattedValue = value
                                                                    if (value === true) formattedValue = 'Yes'
                                                                    else if (value === false) formattedValue = 'No'
                                                                    else if (typeof value === 'string' && value.trim() === '') formattedValue = '—'
                                                                    else if (Array.isArray(value)) {
                                                                        // Handle arrays (like multiselect values)
                                                                        formattedValue = value.map(item => {
                                                                            if (typeof item === 'object' && item.value) {
                                                                                return item.value
                                                                            } else if (typeof item === 'object' && item.id) {
                                                                                return item.id
                                                                            } else {
                                                                                return String(item)
                                                                            }
                                                                        }).join(', ')
                                                                    } else if (typeof value === 'object' && value.value) {
                                                                        // Handle single object with value property
                                                                        formattedValue = value.value
                                                                    } else if (typeof value === 'object' && value.id) {
                                                                        // Handle single object with id property
                                                                        formattedValue = value.id
                                                                    } else if (typeof value === 'object') {
                                                                        // Fallback for other objects
                                                                        formattedValue = JSON.stringify(value)
                                                                    }

                                                                    return (
                                                                        <span key={fieldName} className={`cpb-package-option-form-field ${deviceType}`}>
                                                                            {label}: {formattedValue}
                                                                        </span>
                                                                    )
                                                                }
                                                                return null
                                                            })}
                                                        </div>
                                                    )}
                                                </span>
                                            )
                                        })} */}
                                                <span className={`cpb-price ${deviceType}`}>
                                                    {val.qty} x {val.unitPrice} {val.currency_symbol}
                                                </span>
                                                <span className={`cpb-line-total ${deviceType}`}>
                                                    {val.lineTotal} {val.currency_symbol}
                                                </span>
                                            </div>
                                        </div>
                                        <div className={`cpb-actions ${deviceType}`}>
                                            <i
                                                onClick={() => dispatch(reduxSalesRemoveFromCartSite(i, reduxCacheSite.portfolio!))}
                                                className={`mo-new-icon-trash-solid ${deviceType}`}
                                            />
                                        </div>
                                    </div>
                                    <FormDataDisplaySite
                                        extra_data_json={val.extra_data_json}
                                        form_fields_mapping={val.form_fields_mapping}
                                        package_option_items={val.package_option_items}
                                        currency_symbol={val.currency_symbol}
                                        deviceType={deviceType}
                                        containerClassName="cpb-form-data"
                                        fieldClassName="cpb-form-field"
                                        renderAs="span"
                                    />
                                </div>
                            )
                        })}
                    </div>
                    <div className={`cpb-footer ${deviceType}`}>
                        <p className={`cpb-subtotal ${deviceType}`}>
                            {reduxText[7467]}{' '}{Number(reduxSalesSite.subTotal.toFixed(2))} {reduxSalesSite.currency_symbol}
                        </p>
                        {(reduxSalesSite.salesLines.length > 0) && (
                            <LinkHelperSite
                                action='page_link'
                                className={`cpb-checkout ${deviceType}`}
                                onClick={() => {
                                    if (canCheckout) {
                                        handleClose()
                                        // Add a small delay to ensure navigation happens before scrolling
                                        setTimeout(() => scrollToTop(), 100)
                                    }
                                }}
                                to='checkout'
                            >
                                {canCheckout ? reduxText[7468] : reduxText[7768]}
                            </LinkHelperSite>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}
